import React, { useState, useEffect, useContext } from "react";
import './rightDetails.scss';
import { IoCloseOutline, IoCheckmarkOutline } from "react-icons/io5";
import { BsFillStarFill, BsPencil } from "react-icons/bs";
import { useParams } from 'react-router-dom';
import candidateApi from "../../services/candidateApi";
import masterApi from "../../services/masterApi";
import { useForm, Controller, set } from "react-hook-form";
import { AuthContext } from "../../context/AuthContext";
import { getMailBody } from "../../utils/common";
import { toast } from 'react-toastify';
import Select from "react-select"
import { ThreeDotLoader } from "../../components/Loader/Loader"; // Add this import

export const AddAssesment = ({ closePopup, jobId, reloadData, assessmentId, editMode = false, candidateId }) => {
  const { id } = useParams();   
  const [isLoading, setIsLoading] = useState(false); // Loader state
  const [isEditMode, setIsEditMode] = useState(null);
  const [lookupListPhase, setLookupLstPhase] = useState([]); 
  const [lookupOutcomeLst, setLookupOutcomeLst] = useState([]);  
  const [activeUsersLst, setActiveUsersLst] = useState([]);
  const [activeBoardLst, setActiveBoardLst] = useState([]);
  const [lookupCriteriaLst, setLookupCriteriaLst] = useState([]);
  const { control,register,handleSubmit,reset,setValue, formState: { errors } } = useForm();
  const [isDisabled, setIsDisabled] = useState(true);

  const [ratings, setRatings] = useState([]); 
  const [completedRatings, setCompletedRatings] = useState([]); 
  const [isEditing, setIsEditing] = useState(false); 
  const [selectedCriteria, setSelectedCriteria] = useState("");
  const [selectedCriteria1, setSelectedCriteria1] = useState("");

  const [editingCriteria, setEditingCriteria] = useState(null); // Store the criteria being edited
  const [editingRating, setEditingRating] = useState(null); // Store the rating being edited
  const [assessmentData, setAssessmentData] = useState([]);
  const [candidateDetails, setCandidateDetails] = useState(null);
  const [searchedUsers, setSerarchedUsers] = useState([])

  const { reloadDataFunc } = useContext(AuthContext);
  const { reloadDataRat } = useContext(AuthContext);

  
  useEffect(() => {
    fetchCandidateDetails();
  }, []);

  const fetchCandidateDetails = async () => {
    try{
      setIsLoading(true);
      const response = await candidateApi.getCandidateById(id);
      if(response?.data){
        setCandidateDetails(response.data);
      }
    }
    catch (error) {
      toast.error("Error fetching candidate details:", {
        position: "top-right", 
        autoClose: 2000,
      });
      console.error("Error fetching candidate details:", error);
    }finally {
      setIsLoading(false);
    }
  };
  


  const handleEdit = (criteria) => {
    setIsEditing(true);
    setSelectedCriteria1(criteria); // Set the selected criteria for editing  
    // Set ratings for selected criteria
    const selectedRating = completedRatings.find(r => r.criteria === criteria);
    if (selectedRating) {
      setRatings([{ criteria, value: selectedRating.value }]);
    }
  };  
  const handleSave = () => {
    if (!selectedCriteria) return; // Ensure a criteria is selected before saving  
      const newRating = {
      criteria: selectedCriteria,
      value: ratings.find(r => r.criteria === selectedCriteria)?.value || 0
    };  
    // Update the existing rating if it exists
    setCompletedRatings((prevRatings) => {
      const existingIndex = prevRatings.findIndex(r => r.criteria === selectedCriteria);
      if (existingIndex !== -1) {
        prevRatings[existingIndex] = newRating;
        return [...prevRatings];
      } else {
        return [...prevRatings, newRating];
      }
    });  
    setRatings([]); // Clear selected ratings
    setSelectedCriteria(""); // Reset dropdown selection
    setIsEditing(false); // Disable editing
  };
  const handleSave1 = () => {
    if (!selectedCriteria1) return; // Ensure a criteria is selected before saving  
      const newRating = {
      criteria: selectedCriteria1,
      value: ratings.find(r => r.criteria === selectedCriteria1)?.value || 0
    };
    // Update the existing rating if it exists
    setCompletedRatings((prevRatings) => {
      const existingIndex = prevRatings.findIndex(r => r.criteria === selectedCriteria1);
      if (existingIndex !== -1) {
        prevRatings[existingIndex] = newRating;
        return [...prevRatings];
      } else {
        return [...prevRatings, newRating];
      }
    });
    setRatings([]); // Clear selected ratings
    setSelectedCriteria(""); // Reset dropdown selection
    setIsEditing(false); // Disable editing
  }; 
  const handleRatingChange = (criteria, value) => {
    setRatings((prevRatings) => {
      const updatedRatings = prevRatings.filter((r) => r.criteria !== criteria);
      return [...updatedRatings, { criteria, value }];
    });  
    // Also update completedRatings when editing
    setCompletedRatings((prevRatings) => {
      return prevRatings.map((r) =>
        r.criteria === criteria ? { ...r, value } : r
      );
    });
  };
  const handleRatingChange1 = (criteria, value) => {
    if (!isEditing) return; // Prevent changes if not in editing mode  
      setRatings((prevRatings) => {
      const updatedRatings = prevRatings.filter((r) => r.criteria !== criteria);
      return [...updatedRatings, { criteria, value }];
    });
    // Also update completedRatings when editing
    setCompletedRatings((prevRatings) => {
      return prevRatings.map((r) =>
        r.criteria === criteria ? { ...r, value } : r
      );
    });
  };  
   
  useEffect(() => {  
  const loadPhase = async () => {
    try {
      setIsLoading(true); // Start loading
      const type ='AssessmentPhase';
      const response = await masterApi.getLookups(type); 
      const data = response?.data?.data[0]; 
      if (data) {
          const lookupListPhase = Object.values(data);
          console.log("Extracted Lookup List: ", lookupListPhase);
          setLookupLstPhase(lookupListPhase); // Update the state
      } else {
          console.error("No data found");
      } 
    } catch (error) {
      toast.error("Error fetching assessment phase lookup data", {
        position: "top-right", 
        autoClose: 2000,
      });
      console.error("Error fetching getLookups:", error);
    }finally {
      setIsLoading(false); // Stop loading
    }
  };
  const loadActionOutcome= async () => {
    try {
      setIsLoading(true); // Start loading
      const type ='AssessmentOutcome';
      const response = await masterApi.getLookups(type); 
      const data = response?.data?.data[0]; 
      if (data) {
        const lookupOutcomeList = Object.values(data);
        console.log("Extracted Lookup List: ", lookupOutcomeList);
        setLookupOutcomeLst(lookupOutcomeList); // Update the state
      } else {
          console.error("No data found");
      } 
    } catch (error) {
      toast.error("Error fetching assessment outcome lookup data", {
        position: "top-right", 
        autoClose: 2000,
      });
      console.error("Error fetching getLookups:", error);
    }finally {
      setIsLoading(false); // Stop loading
    }
  };
  const loadActionTakenBy = async () => {
    try {
      setIsLoading(true); // Start loading
      const response = await masterApi.getActiveUsers();
      const data = response?.data?.users; 
      if (data) {
        // const userList = Object.values(data);
        const userList = data.map(user => ({label: `${user.firstName} ${user.lastName}`, ...user}))
        setActiveUsersLst(userList);   
      } else {
        console.error("No data found");
      }   
    } catch (error) {
      toast.error("Error fetching active users", {
        position: "top-right", 
        autoClose: 2000,
      });
      console.error("Error fetching users:", error);
    }finally {
      setIsLoading(false); // Stop loading
    }
  };
  const loadCriteria= async () => {
    try {
      setIsLoading(true); // Start loading
      const type ='AssessmentCriteria';
      const response = await masterApi.getLookups(type); 
      const data = response?.data?.data[0]; 
      if (data) {
          const lookupCriteriaList = Object.values(data);
          console.log("Extracted Lookup List: ", lookupCriteriaList);
          setLookupCriteriaLst(lookupCriteriaList); // Update the state
      } else {
          console.error("No data found");
      } 
    } catch (error) {
      toast.error("Error fetching assessment criteria", {
        position: "top-right", 
        autoClose: 2000,
      });
      console.error("Error fetching assessment criteria:", error);
    }finally {
      setIsLoading(false); // Stop loading
    }
  };
  const loadBoard = async () => {
    try {
      setIsLoading(true); // Start loading
      const response = await masterApi.getActiveBoard();
      const data = response?.data?.activeboards; 
      if (data) {
        const boardList = Object.values(data);
        setActiveBoardLst(boardList);  
      } else {
        console.error("No data found");
      }   
    } catch (error) {
      toast.error("Error fetching assessment criteria", {
        position: "top-right", 
        autoClose: 2000,
      });
      console.error("Error fetching boards:", error);
    }finally {
      setIsLoading(false); // Stop loading
    }
  }; 
  loadActionTakenBy();
  loadActionOutcome();
  loadPhase();
  loadCriteria();
  loadBoard();
}, []);
useEffect(() => {
  if (editMode) {
    const fetchData = async () => {
      try{
        setIsLoading(true); // Start loading
        const response1 = await candidateApi.getAssessmentByAssessmentId(assessmentId); // API to get candidate by ID
        const assessments = response1?.data?.assessment ? Object.values(response1.data.assessment) : [];
        const ratings = response1?.data?.ratings ? Object.values(response1.data.ratings) : []; 
        let assessmentRatings = [];
        const transformedData = assessments.map((item) => {  
          assessmentRatings = ratings
          .filter(rating => rating.assessmentId === item.assessmentId)
          .map(rating => ({
            criteria: rating.criteria,  // Ensure criteria is included
            value: rating.rating,        // Ensure rating value is included
          })); 
          const assessmentDate = new Date(item.assessmentDate); 
          const datePart = assessmentDate.toISOString().split("T")[0];
          const timePart = assessmentDate.getUTCHours().toString().padStart(2, "0") + ":" + 
            assessmentDate.getUTCMinutes().toString().padStart(2, "0");
            reset ({
              id: item.assessmentId,
              phase: item.phase,
              // actionTakenBy: item.doneBy,
              actionTakenBy: {label: `${item.firstName} ${item.lastName}`, id: item.doneBy, ...item},
              date: datePart,
              time:timePart,
              actionOutcome: item.outcome,
              moveTo: item.moveToBoardId,
              remarks: item.remarks,
              ratings: assessmentRatings,
            });                        
        });
        setCompletedRatings(assessmentRatings);
        setAssessmentData(transformedData);  
      }
      catch (error) {
        toast.error("Error fetching assessment data", {
          position: "top-right", 
          autoClose: 2000,
        });
      }finally {
        setIsLoading(false); // Stop loading
      }
    };
    fetchData(); 
  }
}, [editMode, assessmentId, candidateApi, reset]);


const onSubmit = async (data) => {   
  try {
    setIsLoading(true);
  const activityDate = `${data.date} ${data.time}:00`;
  const transformedRatings = completedRatings.map(({ criteria, value }) => ({
    criteria,
    rating: value
  }));
  let selectedcandidateId;

if (id) {
  selectedcandidateId = id;
} else {
  selectedcandidateId = candidateId;
}
  const requestData = {
    assessmentId:assessmentId?assessmentId :'',
    candidateId:selectedcandidateId,
    jobId: jobId,
    phase: data.phase,
    doneBy: data.actionTakenBy.id,
    assessmentDate: activityDate,
    outcome: data.actionOutcome,
    moveToBoardId: data.moveTo ?? null,
    ratings: transformedRatings,
    remarks: data.remarks,
  }; 
  
    let response;
    let alertMessage;
    if(assessmentId){ 
      response = await candidateApi.updateAssessmentWithRatings(requestData);  
      if(response?.ok){
        alertMessage = "Assessment updated successfully";
        toast.success(alertMessage, {
          position: "top-right",
          autoClose: 2000,
        })
      }
      else{
        alertMessage = "Assessment could not be updated";
        toast.error(alertMessage, {
          position: "top-right",
          autoClose: 2000,
        })
      }
    }else{
      response = await candidateApi.insertAssessmentWithRatings(requestData); 
      if(response?.data?.ok){
        alertMessage = "Assessment added successfully";
        toast.success(alertMessage, {
          position: "top-right",
          autoClose: 2000,
        })
      }
      else{
        alertMessage = "Assessment could not be added";
        toast.error(alertMessage, {
          position: "top-right",
          autoClose: 2000,
        })
      }
    }
    
    // if(response?.ok){
    //   toast.success(alertMessage, {
    //     position: "top-right",
    //     autoClose: 2000,
    //   })
    // }
    // else{
    //   toast.error(alertMessage, {
    //     position: "top-right",
    //     autoClose: 2000,
    //   })
    // }
    // if (reloadData) {  
    //   reloadData();  
    // } 
    if (reloadDataFunc) {
      reloadDataFunc();  // Call the function stored in context to reload `LeftDetails`
    }
    if (reloadDataRat) {
      reloadDataRat();  // Call the function stored in context to reload `LeftDetails`
    }
    
    
    if(response?.data?.ok && data.actionOutcome === "26"){
        const rejectedMailData = {
          firstName: candidateDetails?.firstName,
          lastName: candidateDetails?.lastName, 
          mailAddress: candidateDetails?.email,
          isRejected: true,
          isUsercreation: false,
        }
        try{
            const response =   await masterApi.sendNotificationMail(rejectedMailData);
            if(response?.data?.ok){
              toast.success(response?.data?.message, {
                position: "top-right",
                autoClose: 2000,
              })
        }
        }
        catch (error) {
          toast.error(response?.response?.data?.error, {
            position: "top-right",
            autoClose: 2000,
          })
        }
    }
    
    closePopup();
    console.log("Activity inserted successfully:", response);
  }catch (error) {
    console.error("Error submitting activity:", error);
  }finally {
    setIsLoading(false); // Stop loading
  }
}
  return (
    <div className="popup-container ">
      <div
        className="shadeClose"
        onClick={() => {
          closePopup();
        }}
      ></div>
      <div className="popup-inner">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="inner-design">
          <div className="popup-header d-flex align-items-center gap2">
            <h2>{editMode ? "Edit Assessment":"Add Assessment"}</h2>
            <button
              type="button"
              className="ms-auto close-btn"
              onClick={() => {
                closePopup();
              }}
            >
              <IoCloseOutline />
            </button>
          </div>

          <div className="popup-content">
            <div className="row">
              <div className="col-12 col-md-6 mb-4">
                <label className="form-label" htmlFor="jobTitle">
                  Phase <span className="asterisk danger">*</span>
                </label>
                < Controller
              name="phase"
              control={control}
              rules={{
                required: 'Phase is required', // Validation rule
              }}
              render={({ field }) => (
                <select {...field}
                 className={`form-select ${errors.phase ? "is-invalid" : ""}`} >
                  <option value="">Select</option>
                  {lookupListPhase?.map((lookups) => (
                  <option key={lookups.id} value={lookups.id}>
                  {lookups.value}
                </option>
              ))}
                </select>
              )} />
              </div>
              <div className="col-12 col-md-6 mb-4">
                <label className="form-label" htmlFor="jobTitle">
                  Done by <span className="asterisk danger">*</span>
                </label>
              < Controller
              name="actionTakenBy"
              control={control}
              rules={{
                required: 'Done by is required', // Validation rule
              }}
              render={({ field }) => (
                <Select {...field}
                  options={searchedUsers}
                  className={`form-select ${errors.actionTakenBy ? "is-invalid" : ""}`}
                  value={field.value}
                  onInputChange={input => {
                    if(input.length >= 3){
                      const users = activeUsersLst.filter(user => user.label.toLowerCase().startsWith(input.toLowerCase()))
                      setSerarchedUsers(users)
                    }
                    else{
                      setSerarchedUsers([])
                    }
                  }}
                  onChange={e => {
                    field.onChange(e)
                  }}
                  isSearchable
                   >
                </Select>
              )} 
              />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6 mb-4">
                <label className="form-label" htmlFor="jobTitle">
                  Date & Time <span className="asterisk danger">*</span>
                </label>
                <div className={`${errors.date || errors.time ? "required form-control p-0 d-flex gap-1 input-holder" :
                 "form-control p-0 d-flex gap-1 input-holder"}`}   >
                  <input type="date" {...register("date", {
                    required: "Date is required", })}/>
                  <input type="time" {...register("time", {
                    required: "Time is required", })}/>
                </div>
              </div>
              <div className="col-12 col-md-6 mb-4">
                <label className="form-label" htmlFor="jobTitle">
                  Outcome <span className="asterisk danger">*</span>
                </label>
                < Controller
                name="actionOutcome"
                control={control}
                rules={{
                  required: 'Action taken is required', // Validation rule
                }}
                render={({ field }) => (
                  
                <select {...field}
                  className={`form-select ${errors.actionOutcome ? "is-invalid" : ""}`}>
                  
                  <option value="">Select</option>
                    {lookupOutcomeLst?.map((lookups) => (
                  <option key={lookups.id} value={lookups.id}>
                    {lookups.value}
                  </option>
                ))}
                  </select>
                )} />
              </div>
              {/* <div className="col-12 col-md-6 mb-4">
                <label className="form-label" htmlFor="jobTitle">
                  Move to
                </label>
                <select
                  className="form-select" {...register("moveTo")}>
                  <option value="">Select</option>
                  {activeBoardLst?.map((Board) => (
                  <option key={Board.id} value={Board.id}>
                  {Board.boardName} 
                  </option>
                ))}
                </select>
              </div> */}
            </div>
            <div className="row">
              <div className="col-12 col-md-12 mb-4">
                <label className="form-label">
                  Remarks
                </label>
                <textarea {...register("remarks", )} className="form-control" placeholder="Please enter the notes about the action"></textarea>
              </div>
            </div>
            <h6 className="with-border my-3"><span>Rate the Candidate</span></h6>
            <div className="row">
              <div className="col-12 col-md-6 mb-4">
                <label className="form-label" >
                  Label
                </label>
                <select
                  className="form-select" value={selectedCriteria}
                  onChange={(e) => setSelectedCriteria(e.target.value)}>
                  <option value="">Select</option>
                    {lookupCriteriaLst?.map((lookups) => (
                  <option key={lookups.id} value={lookups.id}>
                    {lookups.value}
                  </option>
                ))}
                </select>
              </div>
              <div className="col-12 col-md-4 mb-4">
                <label className="form-label" >
                  Add your rating
                </label>
                {/* {!isEditing && ( */}
                <div className="rating-holder d-flex gap-3 align-items-center">
                
                  {[1, 2, 3, 4, 5].map((star) => (
                  <div className="rate-input position-relative">
                    {/* <input type="checkbox" />
                    <BsFillStarFill /> */}
                    
                      <label key={star} className="rate-input">
                        <input
                          type="checkbox"
                          checked={ratings.find(r => r.criteria === selectedCriteria)?.value >= star}
                          onChange={() => handleRatingChange(selectedCriteria, star)}
                        />
                        <BsFillStarFill className={ratings.find(r => r.criteria === selectedCriteria)?.value >= star ? "text-warning" : ""} />
                      </label>
                    
                  </div>
                ))}</div>
                {/* )} */}
              </div>
              <div className="col-12 col-md-2 mb-4 ms-auto text-end">
                <label className="form-label visibility-hidden" >
                  Action
                </label>
                <button type="button" className="btn btn-primary btn-sm " onClick={handleSave}>
                  <span className="font-size-medium me-2"><IoCheckmarkOutline /></span>
                  Save
                </button>
              </div>
            </div>
            <hr className="mt-0" />
            {/* repeat row for rated  */}
            {completedRatings.map((rated, index) => (
            <div className="row assesment-value-holder" key={rated.criteria}>
              <div className="col-12 col-md-6 mb-4">

                <select
                  className="form-select" disabled={isEditing && selectedCriteria !== rated.criteria}
                  value={rated.criteria}>
                  <option value="">Select</option>
                    {lookupCriteriaLst?.map((lookups) => (
                  // <option key={lookups.id} value={lookups.id}>
                  <option key={lookups.id} value={lookups.id}>
                    {lookups.value}
                  </option>
                ))}
                </select>
              </div>
              <div className="col-12 col-md-4 mb-4">
                <div className="rating-holder d-flex gap-3 align-items-center">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div key={star} className="rate-input position-relative">
                    <input type="checkbox" checked={rated.value >= star} disabled={isEditing && selectedCriteria1 !== rated.criteria}
              onChange={() => handleRatingChange1(rated.criteria, star)} />
                    <BsFillStarFill className={rated.value >= star ? "text-warning" : ""} />
                  </div>
                  ))}</div>
              </div>
              <div className="col-12 col-md-2 mb-4 ms-auto d-flex">
              {isEditing && selectedCriteria1 === rated.criteria ? (

                <button type="button" onClick={handleSave1} className="btn btn-primary btn-sm ms-auto">
                <span className="font-size-medium "><IoCheckmarkOutline /></span>
                </button>
                  
              ) : (
                <button type="button" onClick={() => handleEdit(rated.criteria)} className="btn btn-primary btn-sm ms-auto">
                <span className="font-size-medium "><BsPencil /></span>
                </button> 
                
              )}
              </div>
            </div>
            ))}
            </div>

          <div className="popup-footer position-absolute w-100 d-flex">
            <div className="ms-auto d-flex gap-2">
              <button type="button" className="btn btn-dark btn-lg" onClick={closePopup}>
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-success btn-lg"

              >{editMode ? "Update" : "Add"}</button>
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>
  );
}   